// src/components/WhyChooseUs.tsx
import React from 'react';
import '../styles/WhyChooseUs.css';
import '../styles/PetAdoptionPage.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import avatar from '../resources/dog5.jpg'; // Adjust the path as necessary
import { 
  faHandHoldingHeart, 
  faShieldAlt, 
  faHome, 
  faPaw, 
  faHeartPulse, 
  faMagnifyingGlassPlus
} from '@fortawesome/free-solid-svg-icons';

const WhyChooseUs: React.FC = () => {
  return (
    <div className="why-choose-us-section">
      <div className="container">
        <div className="section-header">
          <h2>Why Choose Our Pet Adoption Service?</h2>
          <p>Discover what makes us the perfect choice for finding your new furry family member</p>
        </div>
        
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faHeartPulse} />
            </div>
            <div className="feature-content">
              <h3>Health Guarantee</h3>
              <p>All pets receive comprehensive health checks, vaccinations, and a 30-day health guarantee.</p>
            </div>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faMagnifyingGlassPlus} />
            </div>
            <div className="feature-content">
              <h3>Perfect Matching</h3>
              <p>Our expert system considers lifestyle and preferences to find your ideal companion.</p>
            </div>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faHandHoldingHeart} />
            </div>
            <div className="feature-content">
              <h3>Lifetime Support</h3>
              <p>Receive ongoing support, training resources, and veterinary advice for the lifetime of your pet.</p>
            </div>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faShieldAlt} />
            </div>
            <div className="feature-content">
              <h3>Transparent History</h3>
              <p>Complete medical and behavioral history for every animal ensures you know who you're adopting.</p>
            </div>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faHome} />
            </div>
            <div className="feature-content">
              <h3>Home Trial Period</h3>
              <p>Two-week trial period to ensure the perfect fit before finalizing adoption.</p>
            </div>
          </div>
          
          <div className="feature-card">
            <div className="feature-icon">
              <FontAwesomeIcon icon={faPaw} />
            </div>
            <div className="feature-content">
              <h3>Community Network</h3>
              <p>Join our network of pet lovers for events, playdates, and expert workshops.</p>
            </div>
          </div>
        </div>
        
        <div className="stats-section">
          <div className="stat-item">
            <h3>2,500+</h3>
            <p>Pets Adopted</p>
          </div>
          <div className="stat-item">
            <h3>98%</h3>
            <p>Adoption Success Rate</p>
          </div>
          <div className="stat-item">
            <h3>24/7</h3>
            <p>Support After Adoption</p>
          </div>
        </div>
      </div>
      
      <div className="testimonial-container">
        <div className="testimonial-content">
          <div className="quote-icon">
            <p>"</p>
          </div>
          <p className="testimonial-text">Adopting Luna through this service was the best decision we've made. The matching process was so thorough, and the support after adoption has been incredible.</p>
          <div className="testimonial-author">
            <div className="author-avatar">
              <img src="https://randomuser.me/api/portraits/women/32.jpg" alt="Sarah Johnson" />
            </div>
            <div className="author-info">
              <h4>Sarah Johnson</h4>
              <p>Adopted Luna, 2023</p>
            </div>
          </div>
        </div>
        <div className="testimonial-image">
          <img src={avatar}  alt="A happy dog with its new owner" />
       
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;